import {useEffect} from 'react'
import {observer} from 'mobx-react-lite'
import {useLocation} from 'react-router-dom'
import clubStore from '../../../storage/ClubStore'
import Debts from '../ParentMember/Debts'

const MemberDebts = () => {
  const location = useLocation()
  const child = clubStore.child

  useEffect(() => {
    const load = async () => {
      child.setProperty('debts', [])
      if (!child.company_id) return
      if (!child.child_id) await child.getChild()
      if (child.child_id) await child.getDebts()
    }
    load()
  }, [child.company_id, location.pathname])

  return <Debts debts={child.debts} url="/member/billing"/>
}

export default observer(MemberDebts)